import { PlanGate } from "@/components/app/PlanGate";
import Conferencias from "./boloes/Conferencias";

export default function BolaoConferenciasPage() {
  return (
    <PlanGate
      tier="premium"
      featureName="Conferências automáticas"
      description="Acompanhe a conferência de cada bolão a cada novo concurso publicado, com histórico completo."
    >
      <Conferencias />
    </PlanGate>
  );
}